export default {"src":"/_next/static/media/backup-servers.89336dbb.svg","height":512,"width":512,"blurWidth":0,"blurHeight":0};